import { TipoPreviaMensagemEnum } from '../../../../shared/enum/tipo-previa-mensagem.enum';

const PASTA_ICONES_PREVIA = './assets/icones/redesign/modulos/chat/components-message';

export const ICONES_PREVIA_MENSAGEM: Partial<Record<TipoPreviaMensagemEnum, string>> = {
  [TipoPreviaMensagemEnum.FOTO]: `${PASTA_ICONES_PREVIA}/image-gray.svg`,
  [TipoPreviaMensagemEnum.VIDEO]: `${PASTA_ICONES_PREVIA}/video-gray.svg`,
  [TipoPreviaMensagemEnum.AUDIO]: `${PASTA_ICONES_PREVIA}/mic-gray-solid.svg`,
  [TipoPreviaMensagemEnum.FIGURINHA]: `${PASTA_ICONES_PREVIA}/sticker-gray.svg`,
  [TipoPreviaMensagemEnum.DOCUMENTO]: './assets/icones/redesign/files-icons/file.svg',
  [TipoPreviaMensagemEnum.TEMPLATE]: `${PASTA_ICONES_PREVIA}/template-icon-message-gray.svg`,
  [TipoPreviaMensagemEnum.DISPARO]: `${PASTA_ICONES_PREVIA}/disparo-icon-message-gray.svg`
};

export const TIPOS_PREVIA_SOMENTE_ROTULO: TipoPreviaMensagemEnum[] = [TipoPreviaMensagemEnum.TEMPLATE, TipoPreviaMensagemEnum.DISPARO];

export const ALVO_REACAO_POR_TIPO: Partial<Record<TipoPreviaMensagemEnum, string>> = {
  [TipoPreviaMensagemEnum.FOTO]: 'uma foto',
  [TipoPreviaMensagemEnum.VIDEO]: 'um vídeo',
  [TipoPreviaMensagemEnum.AUDIO]: 'um áudio',
  [TipoPreviaMensagemEnum.FIGURINHA]: 'uma figurinha',
  [TipoPreviaMensagemEnum.DOCUMENTO]: 'um documento'
};

export const ALVO_REACAO_PADRAO = 'uma mensagem';
